import { render, staticRenderFns } from "./usage_details.vue?vue&type=template&id=973aeaa0"
import script from "./usage_details.vue?vue&type=script&lang=js"
export * from "./usage_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports